import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App'
import { loadFSANZFoodsFromUrl } from './data/fsanz'
import '@fontsource-variable/inter'
import '@fontsource-variable/syne'
import '@fontsource-variable/dm-sans'
import './index.css'
import './styles/logging-screen.css'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
})

// Try to load a larger food list from public/fsanz-foods.json if present (see design/FSANZ-FOODS.md).
loadFSANZFoodsFromUrl('/fsanz-foods.json')

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
